module.exports = __webpack_public_path__ + "img/map_menu_hover.ffbd1a89.svg";